let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dYecd")).then(() => parcelRequire('2abP8'));